var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-ignore
import { useState, useCallback, libName } from 'lib';
import { LocalizedProvider } from 'react-localized';
import CompHook from './CompHook';
import CompDecoratedFunctional from './CompDecoratedFunctional';
import CompDecoratedClass from './CompDecoratedClass';
import CompTemplates from './CompTemplates';
import CompAlias from './CompAlias';
import locales from '../locales';
export default (function () {
    var _a = useState('en'), locale = _a[0], setLocale = _a[1];
    var toggleLocale = useCallback(function () {
        setLocale(function (prev) { return (prev === 'en' ? 'ru' : 'en'); });
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("h3", { children: libName }), _jsx("hr", {}), _jsx("button", __assign({ type: "button", onClick: toggleLocale }, { children: "Toggle locale" })), _jsx("hr", {}), _jsx(LocalizedProvider, __assign({ locales: locales, selected: locale, alias: {
                    gettext: '__',
                    pgettext: '__p',
                    ngettext: '__n',
                    npgettext: '__np'
                } }, { children: function (_a) {
                    var localeReady = _a.localeReady;
                    return (localeReady
                        ? (_jsxs(_Fragment, { children: [_jsx(CompHook, {}), _jsx("hr", {}), _jsx(CompDecoratedFunctional, {}), _jsx("hr", {}), _jsx(CompDecoratedClass, {}), _jsx("hr", {}), _jsx(CompTemplates, {}), _jsx("hr", {}), _jsx(CompAlias, {})] }))
                        : 'loading locale');
                } }))] }));
});
